<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-toolbar flat color="transparent" height="50">
          <h3 class="hidden-sm-and-down">Danh sách xe ({{totalVehicle}})</h3>
          <h4 class="hidden-md-and-up">Xe ({{totalVehicle}})</h4>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-flex lg12>
          <vehicle-table ref="vehicleTable" :isLoading="isLoading" :datasource="vehicles" :totalItems="totalVehicle" @changePage="changePage" @exportFile="openDialogExportFile"/>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Dialog xuất file -->
    <dialog-export-file ref="dialogExportFile" :loading="loadingExportFile" @export="handleExportFile"/>
    <!-- Dialog xuất file -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VehicleTable from './components/list';
import * as Utils from '@/utils';
import DialogExportFile from '@/components/dialog/DialogExportFile';
import { exportVehicles } from '@/api/vehicle';

export default {
  components: {
    VehicleTable,
    DialogExportFile
  },
  data () {
    return {
      isLoading: false,
      pagination: {
        keySearch: '',
        pageIndex: 1,
        pageSize: 10
      },

      vehicles: [],
      loadingExportFile: false,
      typeFilter: '',
      exportKeySearch: ''
    };
  },
  computed: {
    ...mapGetters(['totalVehicle']),
  },
  created () {
    // code
  },
  methods: {
    ...mapActions(['getVehicles']),
    getDateFormatted (value) {
      return this.$refs.vehicleTable.getDateFormatted(value);
    },

    getVehicleStatus (value) {
      return this.$refs.vehicleTable.getVehicleStatus(value);
    },

    changePage ({ params, typeFilter }) {
      this.isLoading = true;
      this.typeFilter = typeFilter;
      this.exportKeySearch = params.keySearch || '';

      this.getVehicles(params).then(res => {
        this.vehicles = res;
        this.isLoading = false;
      });
    },

    openDialogExportFile () {
      // Backend now returns the whole export in one file, so there's only ever one entry.
      let fileName = `Vehicles-${this.typeFilter}`;
      this.$refs.dialogExportFile.open(1, fileName);
    },

    async handleExportFile (file) {
      this.loadingExportFile = true;

      try {
        const res = await exportVehicles({ keySearch: this.exportKeySearch });
        const blob = new Blob([res.data], { type: res.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${file.name}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.log('exportToExcel -> err', err);
      } finally {
        this.loadingExportFile = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/vehicle/index.vue